var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{ref:"formValidate",attrs:{"model":_vm.formValidate,"rules":_vm.ruleValidate,"label-width":100}},[_c('Card',[_c('tables',{attrs:{"editable":"","columns":_vm.columns,"loading":_vm.tableLoading},model:{value:(_vm.tableData),callback:function ($$v) {_vm.tableData=$$v},expression:"tableData"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }